var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 51,
    viewBox: "0 0 42 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 4.63954H4.66667C2.1 4.63954 0 6.7259 0 9.2759V41.7304C0 44.2804 2.1 46.3668 4.66667 46.3668H16.3333V48.685C16.3333 49.96 17.3833 51.0032 18.6667 51.0032C19.95 51.0032 21 49.96 21 48.685V2.32136C21 1.04636 19.95 0.00317383 18.6667 0.00317383C17.3833 0.00317383 16.3333 1.04636 16.3333 2.32136V4.63954ZM16.3333 39.4123H4.66667L16.3333 25.5032V39.4123ZM37.3333 4.63954H25.6667V9.2759H35C36.2833 9.2759 37.3333 10.3191 37.3333 11.5941V39.4123L25.6667 25.5032V46.3668H37.3333C39.9 46.3668 42 44.2804 42 41.7304V9.2759C42 6.7259 39.9 4.63954 37.3333 4.63954Z",
    fill: "#044434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.532ed949e12571ea5a700793010275e6.svg";
export { ForwardRef as ReactComponent };